'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaEnvira = function FaEnvira(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 18.2q-2.3-4.4-3.6-6.2-3.1-4.5-7.7-7.1-0.8-0.4-1.6-0.8-2-0.9-2.1-0.7t0.8 0.8l0.9 0.7q1.3 1 2.5 2.1t2.1 2.6 1.5 2.5 1.6 3q0.2 0.3 0.3 0.5 1 1.9 1.9 3.4t2.2 3.5 2.6 3.3 2.9 2.8 3.3 2q3.4 1.5 3.4 1.3 0.1 0-1.1-0.8-1.1-0.8-1.8-1.3-1.7-1.3-4-4.7t-4.1-6.9z m-7.7 12.1q-1.7-1.3-3-2.8t-2.2-3.2-1.6-3.4-1.3-4.2-1.1-4.6-1.4-5.6-1.7-6.5q6.1 0 11.1 0.8t8.5 2.1 6 3.2 4.2 3.8 2.4 4.5 1.3 4.4 0.2 4.4-0.2 3.9-0.4 3.2-0.3 2.4l7.2 7.3h-2.3l-6.3-6.4q-0.5 0.1-2 0.4t-2.7 0.4-3.1 0.1-3.6-0.4-3.8-1.3-3.9-2.5z' })
        )
    );
};

exports.default = FaEnvira;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/envira.js
// module id = 551
// module chunks = 79611799117203